// ⚠ ASSET DIET (Aug 29): heroNebula + astronaut carry BAKED Cloudinary transforms
// (f_auto,q_auto + width). The raw originals are 6.3MB and 7.4MB — serving them
// untransformed is what made "photos disappear" on weak mobile connections.
// Never strip the transform segment from these URLs; EVENTS covers stay raw here
// because Hero.tsx / Events.tsx bake their own width transforms per placement.
export const ASSETS = {
  heroNebula: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_1600/far/space/hero-nebula',
  astronaut: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_900/far/space/astronaut',
};

// Public ClickUp Demo Submission form — feeds the Demo Submissions list + AI screen pipeline.
export const DEMO_FORM_URL =
  'https://forms.clickup.com/90141429167/f/2kydj3df-534/0LTSZ81H8526206OI9';

// Short labels so the full menu fits as ONE row on the mobile menu bar and on
// desktop widths. 'Social' tab REMOVED (Ryan, Aug 29) to give the remaining six
// room — the merged Instagram section still exists (hidden #social anchor too);
// restore { label: 'Social', href: '#social' } to bring the tab back.
// NOTE: 'Artists' link removed with the archived Artists section — restore alongside
// re-mounting components/sections/Artists.tsx in App.tsx.
// ORDER (Ryan, Aug 29) follows the on-page section flow:
// Shows → Production → Records → AstroSwag → About → Submit Demo.
export const NAV_LINKS = [
  { label: 'Shows', href: '#events' },
  { label: 'Production', href: '#stage' },
  { label: 'Records', href: '#records' },
  { label: 'AstroSwag', href: '#astroswag' },
  { label: 'About', href: '#about' },
  { label: 'Submit Demo', href: DEMO_FORM_URL },
];

export type Pillar = {
  title: string;
  description: string;
  icon: 'events' | 'records' | 'stage';
};

export const PILLARS: Pillar[] = [
  {
    title: 'Upcoming Shows',
    description: 'Gulf Coast shows built around house, dubstep, riddim and drum & bass.',
    icon: 'events',
  },
  {
    title: 'Record Label',
    description: 'Future Astronaut Records — releasing the artists shaping our sound since 2019.',
    icon: 'records',
  },
  {
    title: 'Event Production',
    description: 'Full-scale staging, lighting, sound and visuals for festivals and venues.',
    icon: 'stage',
  },
];

export type EventItem = {
  cover: string;
  title: string;
  date: string;
  time: string;
  venue: string;
  city: string;
  presenter: string;
  tickets: string;
};

export const EVENTS: EventItem[] = [
  {
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/far/events/flux-pavilion',
    title: 'LDW ft. Flux Pavilion + Yookie',
    date: 'Sep 6–7, 2026',
    time: '8PM',
    venue: "Laguna's Beach Bar + Grill",
    city: 'Pensacola, FL',
    presenter: "Presented by Laguna's",
    tickets:
      'https://www.eventbrite.com/e/ldw-at-lagunas-featuring-flux-pavilion-tickets-1994237706664',
  },
  {
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/far/events/niiko-swae',
    title: 'Niiko x Swae — Rooftop',
    date: 'Sep 12, 2026',
    time: '5PM',
    venue: 'Hotel Effie Sandestin',
    city: 'Miramar Beach, FL',
    presenter: 'Presented by Floored Entertainment',
    tickets: 'https://www.eventbrite.com/e/niiko-x-swae-miramar-beach-fl-tickets-1997979680007',
  },
  {
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/far/events/costa',
    title: 'Costa',
    date: 'Oct 9–10, 2026',
    time: '8PM',
    venue: "Laguna's Beach Bar + Grill",
    city: 'Pensacola, FL',
    presenter: "Presented by Laguna's",
    tickets: 'https://www.eventbrite.com/e/costa-pensacola-beach-fl-tickets-1992070693068',
  },
];

// ── FREE DOWNLOADS (the hidden crate, opened from the Records section) ───────
// Index 0 = the featured latest drop; the rest fill the grid, newest first.
// PLACEHOLDERS for now (Ryan, Aug 29) — real rows come from the ClickUp release
// task (WAV + cover) with the owned download gate in front of every file:
// gate = https://download.futureastronautco.com/g/<release code>. Previous
// remixes get loaded when Ryan supplies audio + cover art.
export type FreeDownload = {
  code: string;
  title: string;
  artist: string;
  subgenre: string;
  cover: string;
  gate: string;
};

export const FREE_DOWNLOADS: FreeDownload[] = [
  {
    code: 'FAR-DL-PH01',
    title: 'Placeholder — Latest Drop',
    artist: 'Coming Soon',
    subgenre: 'house',
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_800/far/space/hero-nebula',
    gate: '#',
  },
  {
    code: 'FAR-DL-PH02',
    title: 'Placeholder Track 02',
    artist: 'Coming Soon',
    subgenre: 'dubstep',
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_600/far/space/astronaut',
    gate: '#',
  },
  {
    code: 'FAR-DL-PH03',
    title: 'Placeholder Track 03',
    artist: 'Coming Soon',
    subgenre: 'house',
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_600/far/space/hero-nebula',
    gate: '#',
  },
  {
    code: 'FAR-DL-PH04',
    title: 'Placeholder Track 04',
    artist: 'Coming Soon',
    subgenre: 'deep dub',
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_600/far/space/astronaut',
    gate: '#',
  },
  {
    code: 'FAR-DL-PH05',
    title: 'Placeholder Track 05',
    artist: 'Coming Soon',
    subgenre: 'drum & bass',
    cover: 'https://res.cloudinary.com/kn1rv77n/image/upload/f_auto,q_auto,w_600/far/space/hero-nebula',
    gate: '#',
  },
];

export const EMBEDS = {
  spotify:
    'https://open.spotify.com/embed/playlist/4DIhEMrY1ePgaWRtZO3VFR?utm_source=generator&theme=0',
  soundcloudVisual:
    'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/futureastronautco&color=%238b5cff&visual=true',
  // Classic (non-visual) style — compact tracklist, no bulky cover art
  soundcloudMoonMix:
    'https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/futureastronautco/sets/future-astronaut-records-moon&color=%23c86bff&hide_related=true&show_comments=false&show_user=true&show_reposts=false',
};

export type Artist = { name: string; city: string };

// ARCHIVED with the Artists section — kept for restoration.
export const ARTISTS: Artist[] = [
  { name: 'Meachie', city: 'Chicago, IL' },
  { name: 'Anoe', city: 'Saraland, AL' },
  { name: 'Zewmob', city: 'Nashville, TN' },
  { name: 'Morbeato', city: 'Denver, CO' },
  { name: 'Bad Color', city: 'Nashville, TN' },
  { name: 'Hiede', city: 'Saraland, AL' },
];

export const SERVICES = [
  { title: 'Stage & Rigging', detail: 'Decks, roofs, truss and load plots for any footprint.' },
  { title: 'Lighting Design', detail: 'Programmed looks, fixtures and timecode for every set.' },
  { title: 'Sound Systems', detail: 'Line array design, tuning and monitor world.' },
  { title: 'LED & Visuals', detail: 'Panels, processing and content playback.' },
  { title: 'Show Production', detail: 'Advancing, scheduling and day-of show calling.' },
];

export type SwagItem = { name: string; tag: string; image: string };

export const SWAG: SwagItem[] = [];

export type Social = {
  platform: string;
  handle: string;
  href: string;
  icon: 'instagram' | 'tiktok' | 'soundcloud' | 'spotify';
};

export const SOCIALS: Social[] = [
  {
    platform: 'Instagram',
    handle: '@futureastronautco',
    href: 'https://instagram.com/futureastronautco',
    icon: 'instagram',
  },
  {
    platform: 'Instagram',
    handle: '@futureastronautrecords',
    href: 'https://instagram.com/futureastronautrecords',
    icon: 'instagram',
  },
  {
    platform: 'TikTok',
    handle: '@futureastronautco',
    href: 'https://tiktok.com/@futureastronautco',
    icon: 'tiktok',
  },
  {
    platform: 'SoundCloud',
    handle: 'futureastronautco',
    href: 'https://soundcloud.com/futureastronautco',
    icon: 'soundcloud',
  },
];

export const INSTAGRAM_URL = 'https://www.instagram.com/futureastronautco/';

export const SPOTIFY_PLAYLIST_URL =
  'https://open.spotify.com/playlist/4DIhEMrY1ePgaWRtZO3VFR';
